import clsx from "clsx";
import { Fragment } from "react";

import { Author } from "@/shared/ui/author";
import { Body, Heading } from "@/shared/ui/typography";

import type { EventProgram } from "./model/schemas";

import s from "./event-program-table.module.scss";

export const EventProgramTable = (program: EventProgram) => {
  return (
    <table className={s.root}>
      {program?.title != null && program.title !== "" && (
        <caption>
          <Heading level={6} className={s.title}>
            {program.title}
          </Heading>
        </caption>
      )}
      {/* <thead>
        <tr>
          <th>Время</th>
          <th>Описание</th>
        </tr>
      </thead> */}

      <tbody>
        {program?.sector?.map((sector) =>
          sector ? (
            <Fragment key={sector?.id ?? sector?.sectorName ?? Math.random()}>
              <tr className={s.row}>
                <Body
                  tag="th"
                  colSpan={2}
                  weight="semiBold"
                  scope="rowgroup"
                  className={s.sectorName}
                >
                  {sector?.sectorName ?? ""}
                </Body>
              </tr>

              {sector?.timeSlot?.map((slot) =>
                slot ? (
                  <tr
                    key={slot?.id ?? slot?.time ?? Math.random()}
                    className={clsx(s.row, s.slot)}
                  >
                    <Body tag="td" weight="semiBold" className={s.cell}>
                      {slot?.time ?? ""}
                    </Body>
                    <Body tag="td" className={clsx(s.cell, s.description)}>
                      {slot?.slotDetails?.description != null && (
                        <Body>{slot.slotDetails.description}</Body>
                      )}

                      {slot?.slotDetails?.speaker && (
                        <Author data={slot.slotDetails.speaker} />
                      )}
                    </Body>
                  </tr>
                ) : null,
              )}
            </Fragment>
          ) : null,
        )}
      </tbody>
    </table>
  );
};
